import type React from 'react';
import { useIsOnExitLoading, useLoading } from '../contexts/IdVerificationContext';
import IdvSpinner from '../IdvSpinner';

/**
 * Renders <IdvSpinner /> if some IdVerificationCallback is loading, otherwise
 * renders children
 */
export default function LoadingWrapper({ children }: React.PropsWithChildren) {
  const isOnExitLoading = useIsOnExitLoading();
  const loading = useLoading();

  if (loading || isOnExitLoading) {
    return <IdvSpinner />;
  }

  return children;
}
